module.exports = __webpack_public_path__ + "static/media/aboutimg6.337d8506.webp";